module.exports = __webpack_public_path__ + "static/3.1-94479bc5fb35803589ae1b24c9432356.jpg";